var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50008V1.66675H15V7.50008",
    stroke: "#34B714",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 15H3.33335C2.89133 15 2.4674 14.8244 2.15484 14.5118C1.84228 14.1993 1.66669 13.7754 1.66669 13.3333V9.16667C1.66669 8.72464 1.84228 8.30072 2.15484 7.98816C2.4674 7.6756 2.89133 7.5 3.33335 7.5H16.6667C17.1087 7.5 17.5326 7.6756 17.8452 7.98816C18.1578 8.30072 18.3334 8.72464 18.3334 9.16667V13.3333C18.3334 13.7754 18.1578 14.1993 17.8452 14.5118C17.5326 14.8244 17.1087 15 16.6667 15H15",
    stroke: "#34B714",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667H5V18.3334H15V11.6667Z",
    stroke: "#34B714",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.22347f5a30968512f4847a21335313ea.svg";
export { ForwardRef as ReactComponent };